import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import enTranslations from './locales/en.json';
import viTranslations from './locales/vi.json';

const resources = {
  en: {
    translation: enTranslations
  },
  vi: {
    translation: viTranslations
  }
};

// Clear any existing language setting to force Vietnamese default
if (!localStorage.getItem('language')) {
  localStorage.setItem('language', 'vi');
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'vi', // Force Vietnamese as default
    fallbackLng: 'vi',
    interpolation: {
      escapeValue: false // React already does escaping
    },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage']
    }
  });

export default i18n;